import type { OrderProductOptions } from "../OrderProductOptions.js";

export const emptyOptions: OrderProductOptions = {
	creamColor: undefined,
	customerRequirement: undefined,
	extraFruit: false,
	figurines: [],
	glutenFree: false,
	labels: [],
	lactoseFree: false,
	lyingPhoto: undefined,
	macaroons: undefined,
	meringues: false,
	numbers: [],
	standingPhotos: [],
};
